import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 4.53301C9.6831 3.52938 7.86076 2.99725 6 3.00001C4.89299 2.99888 3.7939 3.18657 2.75 3.55501C2.60379 3.6067 2.4772 3.70245 2.38766 3.82906C2.29812 3.95568 2.25002 4.10693 2.25 4.26201V18.512C2.25002 18.632 2.27882 18.7502 2.33398 18.8567C2.38915 18.9633 2.46907 19.055 2.56703 19.1243C2.665 19.1936 2.77815 19.2383 2.89699 19.2548C3.01583 19.2713 3.13689 19.259 3.25 19.219C4.13333 18.9075 5.06333 18.7488 6 18.75C7.995 18.75 9.823 19.457 11.25 20.636V4.53301ZM12.75 20.636C14.2264 19.4141 16.0836 18.747 18 18.75C18.966 18.75 19.89 18.916 20.75 19.22C20.8632 19.26 20.9843 19.2723 21.1033 19.2558C21.2222 19.2392 21.3354 19.1944 21.4334 19.125C21.5314 19.0556 21.6113 18.9638 21.6664 18.8571C21.7215 18.7504 21.7501 18.6321 21.75 18.512V4.26201C21.75 4.10693 21.7019 3.95568 21.6123 3.82906C21.5228 3.70245 21.3962 3.6067 21.25 3.55501C20.2061 3.18657 19.107 2.99888 18 3.00001C16.1392 2.99725 14.3169 3.52938 12.75 4.53301V20.636Z"
        fill={colorValue}
      />
    </svg>
  );
};
